export const Types = {
  RESET_DATA: "supplement/RESET_DATA",
  GET_ALL_SUPPLEMENT: "supplement/GET_ALL_SUPPLEMENT",
  GET_ALL_SUPPLEMENT_SUCCESS: "supplement/GET_ALL_SUPPLEMENT_SUCCESS",
  GET_ALL_SUPPLEMENT_ERROR: "supplement/GET_ALL_SUPPLEMENT_ERROR",
  GET_PAGE_SUPPLEMENT: "supplement/GET_PAGE_SUPPLEMENT",
  GET_PAGE_SUPPLEMENT_SUCCESS: "supplement/GET_PAGE_SUPPLEMENT_SUCCESS",
  GET_PAGE_SUPPLEMENT_ERROR: "supplement/GET_PAGE_SUPPLEMENT_ERROR",
  GET_SUPPLEMENT: "supplement/GET_SUPPLEMENT",
  GET_SUPPLEMENT_SUCCESS: "supplement/GET_SUPPLEMENT_SUCCESS",
  GET_SUPPLEMENT_ERROR: "supplement/GET_SUPPLEMENT_ERROR",
  SHOW_DRAWER_SUPPLEMENT: "supplement/SHOW_DRAWER_SUPPLEMENT",
  HIDE_DRAWER_SUPPLEMENT: "supplement/HIDE_DRAWER_SUPPLEMENT",
  SAVE_SUPPLEMENT: "supplement/SAVE_SUPPLEMENT",
  SAVE_SUPPLEMENT_SUCCESS: "supplement/SAVE_SUPPLEMENT_SUCCESS",
  SAVE_SUPPLEMENT_ERROR: "supplement/SAVE_SUPPLEMENT_ERROR",
  DELETE_SUPPLEMENT: "supplement/DELETE_SUPPLEMENT",
  DELETE_SUPPLEMENT_SUCCESS: "supplement/DELETE_SUPPLEMENT_SUCCESS",
  DELETE_SUPPLEMENT_ERROR: "supplement/DELETE_SUPPLEMENT_ERROR",
  UPDATE_SUSTENANCE_CAPACITY_DATA: "supplement/UPDATE_SUSTENANCE_CAPACITY_DATA",
  UPDATE_RESTRICTION_DATA: "supplement/UPDATE_RESTRICTION_DATA",
  SHOW_HIDE_DRAWER_SUPPLEMENT_DETAILS:
    "supplement/SHOW_HIDE_DRAWER_SUPPLEMENT_DETAILS",
  SHOW_HIDE_DRAWER_CREATE_EDIT_SUPPLEMENT_FORMULATED:
    "supplement/SHOW_HIDE_DRAWER_CREATE_EDIT_SUPPLEMENT_FORMULATED",
};

export const Creators = {
  indexSupplement: (groupId, farmId, isInputSupplier = false) => ({
    type: Types.GET_ALL_SUPPLEMENT,
    payload: {
      groupId,
      farmId,
      isInputSupplier,
    },
  }),
  indexSupplementSuccess: (data) => ({
    type: Types.GET_ALL_SUPPLEMENT_SUCCESS,
    payload: {
      data,
    },
  }),
  indexSupplementError: (error) => ({
    type: Types.GET_ALL_SUPPLEMENT_ERROR,
    payload: {
      error,
    },
  }),
  indexPageSupplement: (
    groupId,
    farmId,
    page = 0,
    sorter = {},
    filters = "",
    size = 10,
    isInputSupplier = false,
    tableFilters,
    tableSorters
  ) => ({
    type: Types.GET_PAGE_SUPPLEMENT,
    payload: {
      groupId,
      farmId,
      page,
      sorter,
      filters,
      size,
      isInputSupplier,
      tableFilters,
      tableSorters,
    },
  }),
  indexPageSupplementSuccess: (data, pagination) => ({
    type: Types.GET_PAGE_SUPPLEMENT_SUCCESS,
    payload: {
      data,
      pagination,
    },
  }),
  indexPageSupplementError: (error) => ({
    type: Types.GET_PAGE_SUPPLEMENT_ERROR,
    payload: {
      error,
    },
  }),
  showSupplement: (groupId, farmId, id, isInputSupplier = false) => ({
    type: Types.GET_SUPPLEMENT,
    payload: {
      groupId,
      farmId,
      id,
      isInputSupplier,
    },
  }),
  showSupplementSuccess: (
    data,
    sustenanceCapacityData,
    farmRestrictionsData
  ) => ({
    type: Types.GET_SUPPLEMENT_SUCCESS,
    payload: {
      data,
      sustenanceCapacityData,
      farmRestrictionsData,
    },
  }),
  showSupplementError: (error) => ({
    type: Types.GET_SUPPLEMENT_ERROR,
    payload: {
      error,
    },
  }),
  showDrawer: (actionType = "edit", id = null, defaultSupplementGroupId = null) => ({
    type: Types.SHOW_DRAWER_SUPPLEMENT,
    payload: {
      actionType,
      id,
      defaultSupplementGroupId,
    },
  }),
  hideDrawer: () => ({
    type: Types.HIDE_DRAWER_SUPPLEMENT,
    payload: {},
  }),
  saveSupplement: (
    groupId,
    farmId,
    id = null,
    supplement,
    saveOptions,
    isInputSupplier = false
  ) => ({
    type: Types.SAVE_SUPPLEMENT,
    payload: {
      groupId,
      farmId,
      id,
      supplement,
      saveOptions,
      isInputSupplier,
    },
  }),
  saveSupplementSuccess: (data, sustenanceCapacityData, saveOptions) => ({
    type: Types.SAVE_SUPPLEMENT_SUCCESS,
    payload: {
      data,
      sustenanceCapacityData,
      saveOptions,
    },
  }),
  saveSupplementError: (error) => ({
    type: Types.SAVE_SUPPLEMENT_ERROR,
    payload: { error },
  }),
  updateSupplementSustenanceCapacityData: (sustenanceCapacityData) => ({
    type: Types.UPDATE_SUSTENANCE_CAPACITY_DATA,
    payload: {
      sustenanceCapacityData,
    },
  }),
  updateFarmRestrictionData: (farmRestrictionsData) => ({
    type: Types.UPDATE_RESTRICTION_DATA,
    payload: {
      farmRestrictionsData,
    },
  }),
  showHideSupplementDetails: (id) => ({
    type: Types.SHOW_HIDE_DRAWER_SUPPLEMENT_DETAILS,
    payload: {
      id,
    },
  }),
  showHideCreateEditSupplementFormulated: (id = null) => ({
    type: Types.SHOW_HIDE_DRAWER_CREATE_EDIT_SUPPLEMENT_FORMULATED,
    payload: {
      id,
    },
  }),
};

const INITIAL_STATE = {
  isLoading: false,
  isLoadingRequestSaveOrUpdate: false,
  data: [],
  pageData: [],
  pagination: {
    page: 0,
    sorter: {},
    filters: "",
    size: 10,
    tableFilters: null,
    tableSorters: null,
  },
  supplementData: null,
  sustenanceCapacityData: null,
  farmRestrictionsData: null,
  drawerVisible: false,
  defaultSupplementGroupId: null,
  drawerDetailsVisible: false,
  drawerCreateEditSupplementFormulatedVisible: false,
  idSupplement: null,
  error: {},
};

export default function supplement(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.RESET_DATA:
      return INITIAL_STATE;
    case Types.GET_ALL_SUPPLEMENT:
      return { ...state, isLoading: true };
    case Types.GET_ALL_SUPPLEMENT_SUCCESS:
      const { data: supplements } = action.payload;
      return { ...state, isLoading: false, data: supplements };
    case Types.GET_ALL_SUPPLEMENT_ERROR:
      const { error } = action.payload;
      return {
        ...state,
        isLoading: false,
        data: null,
        error,
      };
    case Types.GET_PAGE_SUPPLEMENT:
      return {
        ...state,
        isLoading: true,
      };
    case Types.GET_PAGE_SUPPLEMENT_SUCCESS:
      const { data: supplementsPaged } = action.payload;
      return {
        ...state,
        isLoading: false,
        pageData: supplementsPaged,
        pagination: action.payload.pagination,
      };
    case Types.GET_PAGE_SUPPLEMENT_ERROR:
      return {
        ...state,
        pageData: null,
        isLoading: false,
      };
    case Types.GET_SUPPLEMENT:
      return { ...state, isLoadingRequestSaveOrUpdate: true };
    case Types.GET_SUPPLEMENT_SUCCESS:
      return {
        ...state,
        isLoadingRequestSaveOrUpdate: false,
        supplementData: action.payload.data,
        sustenanceCapacityData: action.payload.sustenanceCapacityData,
        farmRestrictionsData:
          { ...action.payload.data?.restriction, status: "I" } || null,
      };
    case Types.GET_SUPPLEMENT_ERROR:
      return {
        ...state,
        isLoadingRequestSaveOrUpdate: false,
        supplementData: null,
        error,
      };
    case Types.SHOW_DRAWER_SUPPLEMENT:
      return {
        ...state,
        drawerVisible: true,
        idSupplement: action.payload.id || null,
        defaultSupplementGroupId: action.payload.defaultSupplementGroupId || null,
      };
    case Types.HIDE_DRAWER_SUPPLEMENT:
      return {
        ...state,
        drawerVisible: false,
        supplementData: null,
        sustenanceCapacityData: null,
        farmRestrictionsData: null,
        defaultSupplementGroupId: null,
      };
    case Types.SAVE_SUPPLEMENT:
      return { ...state, isLoadingRequestSaveOrUpdate: true };
    case Types.SAVE_SUPPLEMENT_SUCCESS:
      return {
        ...state,
        isLoadingRequestSaveOrUpdate: false,
        supplementData: null,
        drawerVisible: action.payload.saveOptions,
      };
    case Types.SAVE_SUPPLEMENT_ERROR:
      return {
        ...state,
        isLoadingRequestSaveOrUpdate: false,
        error: action.payload.error,
      };
    case Types.DELETE_SUPPLEMENT:
      return { ...state, isLoading: true };
    case Types.DELETE_SUPPLEMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case Types.DELETE_SUPPLEMENT_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };
    case Types.UPDATE_SUSTENANCE_CAPACITY_DATA:
      return {
        ...state,
        sustenanceCapacityData: action.payload.sustenanceCapacityData,
      };
    case Types.UPDATE_RESTRICTION_DATA:
      return {
        ...state,
        farmRestrictionsData: action.payload.farmRestrictionsData,
      };
    case Types.SHOW_HIDE_DRAWER_SUPPLEMENT_DETAILS:
      return {
        ...state,
        drawerDetailsVisible: !state.drawerDetailsVisible,
        idSupplement: action.payload.id,
      };
    case Types.SHOW_HIDE_DRAWER_CREATE_EDIT_SUPPLEMENT_FORMULATED:
      return {
        ...state,
        drawerCreateEditSupplementFormulatedVisible:
          !state.drawerCreateEditSupplementFormulatedVisible,
        idSupplement: action.payload.id,
      };
    default:
      return state;
  }
}
